import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import {List, ListItem} from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';

import PageLoading from '../components/PageLoading';
import Dialog from 'material-ui/Dialog';
import SelectCustomer from '../components/SelectCustomer'
import MachineList from '../components/MachineList'

const formStyle = {
  margin: 24
};

export default
@observer class AssignMachinePage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  // Helper method that writes values back to datamodel as fields are changed
  handleValue(event) {
    var field = event.target.dataset.propname;
    var value = event.target.value;
    console.log("handleValue called");
    AppModel.machineAssignmentForm.machine[field]=value;
  }

  assignMachine() {
    AppModelUtils.assignMachine()
    .then(()=> {
        this.context.router.goBack();
    })
    .catch(()=> {
        console.log("Assignment was rejected, staying on page");
    });
  }

  lookupMachineNameForCustomer() {
    console.log("New customer selected, lookup if we have a machine name for that customer already");
    AppModelUtils.lookupMachineNameForCustomer(AppModel.machineAssignmentForm);
  }

  cancel() {
    this.context.router.goBack();
  }

  render() {
    var m = AppModel.machineAssignmentForm.machine;
    let customerIdMap = AppModel.customerIdMap;
    let customerName = customerIdMap.has(m.id_customer) ?
                        customerIdMap.get(m.id_customer).name : null;

    return (
      <PageLoading loading={AppModel.fetchingMachineDetails
          || AppModel.fetchingMachineName
          || AppModel.updatingMachineAssignment
        }>
        <div style={formStyle}>
          <TextField hintText={uiMsg('AP_EXAMPLE_MACHINE_NAME',"E.g. 'DECONX34'")}
                     data-propname="id"
                     fullWidth={true}
                     value={m.id || ""}
                     onChange={this.handleValue}
                     floatingLabelText={
                       m.isIdValid ? uiMsg('MACHINE_ID',"Machine Id")
                       : uiMsg('AP_MACHINE_ID_REQ',"Machine Id (required)")
                     }
                     inputStyle={{color: 'rgba(0, 0, 0, 0.87)'}}
                     disabled={true}
          />
          <SelectCustomer
              showSelf={true}
              targetForm={AppModel.machineAssignmentForm}
              onSelectionChanged={this.lookupMachineNameForCustomer}/>
        <TextField hintText={uiMsg('AP_CUSTOMER_MACHINE_NAME',"Machine name at customer")}
                     data-propname="name"
                     value={m.name || "" }
                     onChange={this.handleValue}
                     fullWidth={true}
                     floatingLabelText={
                       m.isNameValid? uiMsg('AP_MACHINE_CUST_NAME',"Machine name at customer's")
                      : uiMsg('AP_MACHINE_CUST_NAME_REQ',"Machine name at customer's (required)")
                     }
          />
        </div>
        <Toolbar>
          <ToolbarGroup firstChild={true}></ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <FlatButton
                    onTouchTap={this.cancel.bind(this)}>{uiMsg('AP_B_CANCEL',"Cancel")}
            </FlatButton>
            <RaisedButton primary
                          disabled = {!m.isAssignmentValid}
                          onTouchTap={this.assignMachine.bind(this)}>{uiMsg('AP_B_UPDATE',"Update")}
            </RaisedButton>
          </ToolbarGroup>
        </Toolbar>
      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/AssignMachinePage.jsx
 **/